<template>
  <validation-observer ref="observer" v-slot="{ handleSubmit }">
    <b-form @submit.stop.prevent="handleSubmit(onSubmit)">
      <b-card bg-variant="light"
              title="Warning"
              tag="article"
              class="mb-2">
        <b-card-text>
          Deleting your account is permanent.  It cannot be reversed.  If you are the only owner of a private family, that family group will be removed as well.
        </b-card-text>
      </b-card>
      <input id="dummyUserName" type="text" style="display:none;" autocomplete="username">
      <validation-provider v-if="accountProvider === 0"
                           vid="password"
                           name="Password"
                           :rules="{required: true }"
                           v-slot="validationContext">
        <b-form-group
          label-cols-sm="4"
          label="Re-enter Password:"
          label-align-sm="right"
          label-for="password-box">
          <b-form-input id="password-box"
                        type="password"
                        v-model="form.password"
                        :state="getValidationState(validationContext)"
                        autocomplete="new-password"
                        tabindex="4" />
          <b-form-invalid-feedback id="password-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <div class="d-flex justify-content-end">
        <b-button type="button" variant="outline-secondary" tabindex="6" @click="resetPage()">Cancel</b-button>
        <b-button :disabled="postState.inProgress"
                  type="submit"
                  variant="primary"
                  tabindex="5"
                  class="ml-2">
          Submit
        </b-button>
      </div>
      <ApiPostFeedback :post-state="postState" />
    </b-form>
  </validation-observer>
</template>

<script>
  import { mapGetters } from 'vuex'
  import * as apiUtils from '@/logic/general/apiUtils'
  import * as validationUtils from '@/logic/general/validationUtils'
  import ApiPostFeedback from "@/components/ApiPostFeedback"

  export default {
    name: 'EditDeleteAccount',
    components: {
      ApiPostFeedback
    },
    data() {
      return {
        form: {
          password: ""
        },
        postState: {}
      }
    },
    computed: {
      ...mapGetters('authentication', [
        'accountProvider'
      ]),
    },
    methods: {
      getValidationState: function (validationContext) {
        return validationUtils.getValidationState(validationContext)
      },
      onSubmit: function () {
        this.$bvModal.msgBoxConfirm('Are you absolutely sure you want to delete this account?', {centered: true, size: 'sm'})
        .then(value => {
          if (value) {
            this.postState = apiUtils.resetPostState()
            this.axios.post(apiUtils.buildAPIUrl('account/delete'), this.form)
              .then(response => {
                this.postState = response.postState
                this.resetForm()
                this.$auth.removeToken()

                const vm = this
                this.$store.dispatch('authentication/logoff',this)
                  .finally(() => {
                    if (!vm.isPublic) {
                      vm.$store.dispatch('family/loadDefaultFamily', vm)
                    }
                  })   
                this.$router.push({ path: `/` })
              })
              .catch(error => {
                this.postState = error.postState
                this.form.password = ""
                validationUtils.resetFormDelayed(this)
              })
          }
        })
      },
      resetForm: function () {
        this.postState = {}
        this.form = {
          password: ""
        }
        validationUtils.resetFormImmediate(this)
      },
      resetPage: function () {
        this.$emit('force-reset')
      }
    }
  }
</script>